import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { Shortcut } from 'video-react';
import classnames from 'classnames';
import memoize from "memoize-one";

import AnimationMarkerForm from './AnimationMarkerForm';
import AnimationMarkersInPlayer from './AnimationMarkersInPlayer';
import MarkShape from './MarkShape';
import PolyLineSvg from "./PolyLineSvg";
import { styles } from "../util/styleDrawComponent";
import {getStyleOfSize} from "../util/getStyleofSize";
import YouTube from 'react-youtube';
import apiClient from '../util/api-client';
import Loadable from 'react-loading-overlay';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AnimationMarkerLine from './AnimationMarkerLine';
import AnimationCommentsPane from './AnimationCommentsPane';
import YouTubeControls from './YoutubeControls';
import { fetchHeightHeader } from '../shared';
import CommentDetail from './CommentDetail';
import AnimationMarkerPeriod from './AnimationMarkerPeriod';
import { COMMENT_BOX_OPENED_EVENT, createCommentBoxSyncId, announceCommentBoxOpened } from '../util/animation-marker';
const markersVisibilities = ['all', 'circle', 'none'];
const showSVGIndex = 1000;
const hideSVGIndex = 0;

export default class ShowEmbedVideos extends Component {
  constructor(props) {
    super();
    const { baseURL } = props;
    this.state = {
      isMarking: false,
      startX: 0,
      startY: 0,
      currentX: 0,
      currentY: 0,
      currentWidth: 0,
      currentHeight: 0,
      currentShape: 'point',
      shouldShowForm: false,
      markersVisibility: 'all',
      currentTime: 0,
      canvasWidth: 0,
      canvasHeight: 0,
      zIndexSvg: hideSVGIndex,
      listItemSvg: [],
      currentItemSvg: null,
      settingDraw: {
        color: "black",
        lineWidth: 3,
      },
      isLargeScreen: true,
      currentCanvasWidth: 0,
      currentCanvasHeight: 0,
      isShowControlBar: false,
      currentHeight: 0,
      currentWidth: 0,
      player: null,
      loadingText: null,
      isLoading: false,
      isShowModalNotCompareVersion: false,
      totalDuration: 0,
      periodRange: null,
      showPeriodRange: [],
      commentNumber: null,
      isMobileFullScreen: false,
    };
    this.apiClient = apiClient({ baseURL: baseURL });

    this.showSeekBar = this.showSeekBar.bind(this);
    this.hintSeekBar = this.hintSeekBar.bind(this);
    this.playerContainerRef = React.createRef();
    this.commentBoxSyncId = createCommentBoxSyncId('show-embed-video');
  }

  startLoading = loadingText => {
    this.setState({ loadingText, isLoading: true });
  }
  endLoading = () => {
    this.setState({ loadingText: null, isLoading: false });
  }

  componentWillUnmount() {
    document.removeEventListener('tm-modal-back-click', this.handleModalBackClick);
    document.removeEventListener(COMMENT_BOX_OPENED_EVENT, this.handleCommentBoxOpened);
    if (this.timeUpdateInterval) {
      clearInterval(this.timeUpdateInterval);
    }
  }

  handleModalBackClick = (e) => {
    if (!this.props.isOpen) return;

    if (typeof this.closeModal === 'function') {
      this.closeModal();
    } else if (this.props.onClickClose) {
      this.props.onClickClose();
    } else if (this.props.toggle) {
      this.props.toggle();
    }
  };

  componentDidMount() {
    document.addEventListener('tm-modal-back-click', this.handleModalBackClick);
    document.addEventListener(COMMENT_BOX_OPENED_EVENT, this.handleCommentBoxOpened);

    this.reset();
    var width = document.getElementById("animation-player").offsetWidth;
    var height = document.getElementById("animation-player").offsetHeight;

    this.setState({
      canvasWidth: width,
      canvasHeight: height,
      currentCanvasWidth: width,
      currentCanvasHeight: height,
    });
  }
  update = () => {
    let width = document.getElementById("animation-player").offsetWidth;
    let height = document.getElementById("animation-player").offsetHeight;

    if (width !== this.state.canvasWidth) {
      this.setState(
        {
          canvasWidth: width,
          canvasHeight: height,
          listItemSvg: [],
        },
        () => {
          this.ctx = this.canvas.getContext("2d");
          this.ctx.clearRect(
            0,
            0,
            this.state.canvasWidth,
            this.state.canvasHeight
          );
          this.ctx.drawImage(
            this.player.video.video,
            0,
            0,
            this.state.canvasWidth,
            this.state.canvasHeight
          );
        }
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.seekTime !== prevProps.seekTime && this.props.seekTime != null) {
      if (this.state.player && this.state.player.pauseVideo) {
        this.state.player.pauseVideo();
        this.seekTo(this.props.seekTime);
        if (this.props.onSeeked) this.props.onSeeked();
      }
    }

    if (prevProps?.selectedMarker?.id !== this.props?.selectedMarker?.id) {
      this.focusSelectedMarkerInPlayer();
    }
  }

  focusSelectedMarkerInPlayer = () => {
    const { selectedMarker, markers } = this.props;
    if (!selectedMarker) return;

    const markerId = selectedMarker.isComment ? selectedMarker.id : selectedMarker.parent_id;
    const targetMarker = markers.find((marker) => marker.id === markerId);
    if (!targetMarker) return;

    const targetTime = Number(targetMarker.seek_time ?? selectedMarker.time);

    if (this.state.player && Number.isFinite(targetTime)) {
      this.state.player.pauseVideo();
      this.seekTo(targetTime);

      if (this.state.currentTime !== targetTime) {
        this.setState({ currentTime: targetTime });
      }
    }

    this.scrollToMarkerInPreview(markerId);
  };

  scrollToMarkerInPreview = (markerId, attempt = 0) => {
    const preview = this.elementRef?.closest('.wrap-animation-preview');
    const markerElement = this.elementRef?.querySelector(`.marker-${markerId}`);

    if (!preview || !markerElement) {
      if (attempt < 6) {
        setTimeout(() => this.scrollToMarkerInPreview(markerId, attempt + 1), 80);
      }
      return;
    }

    const previewRect = preview.getBoundingClientRect();
    const markerRect = markerElement.getBoundingClientRect();

    const nextTop =
      preview.scrollTop +
      (markerRect.top - previewRect.top) -
      preview.clientHeight / 2 +
      markerRect.height / 2;
    const nextLeft =
      preview.scrollLeft +
      (markerRect.left - previewRect.left) -
      preview.clientWidth / 2 +
      markerRect.width / 2;

    $(preview).stop().animate({
      scrollTop: Math.max(0, nextTop),
      scrollLeft: Math.max(0, nextLeft),
    }, 'slow');
  };

  handleCommentBoxOpened = (event) => {
    if (event.detail?.sourceId === this.commentBoxSyncId) return;

    this.setState({
      shouldShowForm: false,
      isMarking: false,
      showPeriodRange: [],
      periodRange: null,
    });
  }

  openMarkerForm = (nextState = {}, callback) => {
    this.props.updateSelectedMarker(null);
    announceCommentBoxOpened(this.commentBoxSyncId);
    this.setState({
      shouldShowForm: true,
      isMarking: false,
      ...nextState,
    }, callback);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.settingDraw != this.state.settingDraw) {
      this.setState({
        settingDraw: newProps.settingDraw,
      });
    }
  }
  mouseRelativeXY(event) {
    return this.relativeXY(event.clientX, event.clientY);
  }
  mouseRelativeXYDraw(event) {
    return this.relativeXY(
      event.nativeEvent.clientX,
      event.nativeEvent.clientY
    );
  }
  touchRelativeXY(event) {
    return this.relativeXY(event.touches[0].clientX, event.touches[0].clientY);
  }
  relativeXY(eventX, eventY) {
    const player = this.player
    const playerRect = findDOMNode(player).getBoundingClientRect();
    return [
      (eventX - playerRect.left) / playerRect.width * 10000,
      (eventY - playerRect.top) / playerRect.height * 10000,
    ];
  }
  startMark = ({ x, y }) => {
    if (this.state.isMobileFullScreen) return;
    this.state.player.pauseVideo();
    const currentTime = this.state.player.getCurrentTime();
    const duration = this.state.player.getDuration();

    if (this.props.onVideoClicked) {
      this.props.onVideoClicked(currentTime, duration);
    }

    this.setState({
      isMarking: true,
      shouldShowForm: false,
      startX: x,
      startY: y,
      currentX: x,
      currentY: y,
      currentWidth: 0,
      currentHeight: 0,
      currentShape: 'point',
      currentTime,
    });
  }
  moveMark = ({ x, y }) => {
    const { isMarking, startX, startY, isMobileFullScreen } = this.state;
    if (isMobileFullScreen) return;
    if (!isMarking) return;
    const { max, abs } = Math;
    const distance = max(abs(x - startX), abs(y - startY));
    distance > 10 && startX < x && startY < y
      ? this.setState({
        currentWidth: max(x - startX, 0),
        currentHeight: max(y - startY, 0),
        currentShape: 'rect',
      })
      : this.setState({
        currentWidth: 0,
        currentHeight: 0,
        currentShape: 'point',
      })
  }
  endMark = (event) => {
    if(!this.state.isMarking) return
    if (this.state.isMobileFullScreen) return;
    event.stopPropagation();
    event.preventDefault();
    const { currentAnimationId, animationSelectCurrent, toggleShowModalInputInfoOfNotLogin, isInputInfoMationOfNotLogin } = this.props;
    if (currentAnimationId !== animationSelectCurrent) return

    if (gon.is_login || isInputInfoMationOfNotLogin) {
      if (this.props.isOpenNouislider && !this.state.periodRange) {
        Popup.confirm(`範囲の指定が1ヶ所のみです。<br>範囲指定を終了し、コメントを入力しますか？`, {
          confirmText: 'OK',
          success: () => {
            this.props.closeNouislider()
            this.openMarkerForm({ showPeriodRange: [] });
          },
          cancel: () => {
            this.setState({ shouldShowForm: false, showPeriodRange: [], isMarking: false, });
          }
        })
      } else {
        this.openMarkerForm({ showPeriodRange: [] });
      }
      this.disableMmount();
    } else {
      this.setState({
        isMarking: false,
      });
      toggleShowModalInputInfoOfNotLogin()
    }
    this.disableMmount();
  };

  isTouchInsidePlayer = (event) => {
    if (!event || !event.touches || !event.touches[0] || !this.player) return true;
    const playerRect = findDOMNode(this.player).getBoundingClientRect();
    const touchX = event.touches[0].clientX;
    const touchY = event.touches[0].clientY;
    return (
      touchX >= playerRect.left &&
      touchX <= playerRect.right && 
      touchY >= playerRect.top &&
      touchY <= playerRect.bottom
    );
  }

  getMobileOverlayTopOffset = () => {
    if (typeof window === 'undefined' || window.innerWidth > 767) return undefined;

    const pageControl = document.querySelector('.page-control-mobile');
    const playerContainer = document.getElementById('animation-player');
    if (!pageControl || !playerContainer) return undefined;

    const overlap = Math.ceil(
      pageControl.getBoundingClientRect().bottom - playerContainer.getBoundingClientRect().top
    );

    return overlap > 0 ? `${overlap}px` : undefined;
  }
  getStyleOnMode = ()=>{
    const {onMode} = this.props
    let style={}
    onMode ? style ={
      top:0,
      bottom:"unet"
    } : style ={
      top:"unset",
      bottom: '2.8rem'
    }
    return style
  }
  disableMmount(e = "") {
    var menus = document.querySelectorAll(".show-mark-shape");
    menus = [].slice.call(menus);
    menus.forEach(function (element) {
      element.style.pointerEvents = e;
    });
  }
  renderOverlay() {
    return (
      <div
        className="overlay"
        style={{
          ...this.getStyleOnMode(),
          top: this.getMobileOverlayTopOffset(),
          pointerEvents: this.state.isMobileFullScreen ? 'none' : 'auto'
        }}
        onMouseDown={(event) => {
          this.disableMmount("none");
          event.stopPropagation();
          event.preventDefault();
          const [x, y] = this.mouseRelativeXY(event);
          this.startMark({ x, y });
        }}
        onTouchStart={(event) => {
          event.stopPropagation();
          event.preventDefault();
          this.setOption();
          const [x, y] = this.touchRelativeXY(event);
          this.startMark({ x, y });
        }}
        onMouseMove={(event) => {
          event.stopPropagation();
          event.preventDefault();
          const [x, y] = this.mouseRelativeXY(event);
          this.moveMark({ x, y });
        }}
        onTouchMove={(event) => {
          event.stopPropagation();
          event.preventDefault();
          if (!this.isTouchInsidePlayer(event)) {
            this.endMark(event);
            return;
          }
          const [x, y] = this.touchRelativeXY(event);
          this.moveMark({ x, y });
        }}
        onMouseUp={this.endMark}
        onTouchEnd={this.endMark}
        onTouchCancel={this.endMark}
        onMouseLeave={this.endMark}
        onClick={this.setOption}
      ></div>
    );
  }
  openPeriod = (periodRange) => {
    if (this.state.startX === 0 &&
        this.state.startY === 0 &&
        this.state.currentX === 0 &&
        this.state.currentY === 0) {
      this.openMarkerForm({
        periodRange: periodRange,
        startX: 1000,
        startY: 1000,
        currentX: 1000,
        currentY: 1000
      });
    } else {
      this.openMarkerForm({
        showPeriodRange: [],
        periodRange: periodRange,
      });
    }
  }
  onSubmitMarkerForm = (body, files, editorSetting) => {
    const { onSubmitMarkerForm } = this.props;
    const {
      currentX: x,
      currentY: y,
      currentWidth: width,
      currentHeight: height,
      currentShape: shape,
      currentTime: time,
      periodRange
    } = this.state;
    return onSubmitMarkerForm({
      body,
      x,
      y,
      width,
      height,
      shape,
      time,
      files,
      editorSetting,
      periodRange
    }).then(() =>
      this.setState({
        shouldShowForm: false,
        periodRange: null,
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        currentShape: 'point'
      })
    );
  };
  onCloseMarkerForm = () => {
    this.setState(
      {
        shouldShowForm: false,
      },
      () => {
        this.ctx = this.canvas.getContext("2d");
        this.ctx.clearRect(
          0,
          0,
          this.state.canvasWidth,
          this.state.canvasHeight
        );
        this.ctx.drawImage(
          this.player.video.video,
          0,
          0,
          this.state.canvasWidth,
          this.state.canvasHeight
        );
      }
    );
  };
  activeMarkers() {
    const { markers, selectedMarker } = this.props;
    const currentTime = this.state.currentTime ? this.state.currentTime : 0
    const visibleMarkers = markers.filter(_ =>
      (currentTime - 1 <= _.seek_time && _.seek_time <= currentTime + 1) ||
        (_.period_end > 0 && _.seek_time <= currentTime && currentTime - 1 <= _.period_end)
    );

    if (!selectedMarker) return visibleMarkers;

    const selectedMarkerId = selectedMarker.isComment ? selectedMarker.id : selectedMarker.parent_id;
    const selectedMarkerData = markers.find((marker) => marker.id === selectedMarkerId);

    if (!selectedMarkerData || visibleMarkers.some((marker) => marker.id === selectedMarkerData.id)) {
      return visibleMarkers;
    }

    return [...visibleMarkers, selectedMarkerData];
  }
  onTimeUpdate = () => {
    const currentTime = this.state.player ? this.state.player.getCurrentTime() : 0
    const {is_capture_video_youtube} = this.props;
    if (this.state.player && (!is_capture_video_youtube || currentTime !== this.state.currentTime)) {
      this.setState({
        currentTime: currentTime
      });
    }
  }
  seekTo(time) {
    if (this.state.player) {
      this.state.player.seekTo(time);
    }
  }
  onClickMarkersToggler = () => {
    const currentIndex = markersVisibilities.indexOf(this.state.markersVisibility);
    const nextIndex = (currentIndex + 1) < markersVisibilities.length ? currentIndex + 1 : 0;
    this.setState({ markersVisibility: markersVisibilities[nextIndex] });
  }
  refCallback = element => {
    const { getHeightAnimaiton } =this.props
    this.elementRef = element;
    if (element && getHeightAnimaiton) {
      getHeightAnimaiton(element.getBoundingClientRect().height);
    }
  };

  showSeekBar(){
    const { mobile } = this.props
    if(mobile) return
  }

  hintSeekBar(){
    const { mobile } = this.props
    if(mobile) return
  }

  showSeekBarMobile(){
    const { mobile } = this.props
    if(!mobile)
      return
    if (element && playButton){
      this.showSeekBar();
    } else if (playButton){
      playButton.style.display = 'none';
    }
  }

  async draw(e) {
    this.state.player.pauseVideo();
    const currentTime = this.state.player.getCurrentTime()
    this.state.player.seekTo(currentTime, true)
    const { baseURL, currentAnimation, isShowDra, is_show_draw_component, changeIsCaptureVideoYoutube } = this.props;
    if (is_show_draw_component) {
      this.setState(
        {
          isDel: false,
          shouldShowForm: false,
          // isLargeScreen: false,
        },
        () => {
          this.setState(
            {
              canvasHeight: this.state.currentCanvasHeight,
              canvasWidth: this.state.currentCanvasWidth,
            },
          );
        }
      );
      this.setState({
        zIndexSvg: showSVGIndex,
      });
      return
    }
    this.startLoading('画面のキャプチャ中です。少々お待ちください。。。')
    this.setState(
      {
        isDel: false,
        shouldShowForm: false,
        // isLargeScreen: false,
      },
      () => {
        changeIsCaptureVideoYoutube()
        this.setState(
          {
            canvasHeight: this.state.currentCanvasHeight,
            canvasWidth: this.state.currentCanvasWidth,
          },
        );
      }
    );

    const canvas = document.getElementById("canvas");
    const context = canvas.getContext("2d");
    let img = new Image()
    await this.apiClient.post(`/animations/screen_shot_youtube?id=${currentAnimation.id}&time=${currentTime}`)
    .then((data) => {
      img.setAttribute('crossorigin', 'anonymous')
      img.src = data.data.image
      img.onload = () => {
        context.drawImage(
          img,
          0,
          0,
          this.state.canvasWidth,
          this.state.canvasHeight
        );
      }
      this.setState({
        zIndexSvg: showSVGIndex,
      });
    })
    .catch(() => {
      this.reset()
      Popup.alert(I18n.t('shared.one_error_please_try_again'), '', '', {kind: 'akaire'});
    })
    .finally(() =>{
      changeIsCaptureVideoYoutube()
      this.endLoading()
    });
  }

  eraser() {
    this.setState({
      isDel: true,
    });
  }

  capture(e) {
    document.getElementById("animation-player").style["overflow"] = 'unset'
    this.state.player.pauseVideo();
    const currentTime = this.state.player
      ? this.state.player.getCurrentTime()
      : 0;
    const fileDrawName = `draw-video-image-${moment.now()}`;
    const files = [];
    var svgURL = new XMLSerializer().serializeToString(this.svg);
    const canvas = document.getElementById("canvas");
    const context = canvas.getContext("2d");
    var img = new Image();
    img.onload = () => {
      context.drawImage(
        img,
        0,
        0,
        this.state.canvasWidth,
        this.state.canvasHeight
      );
      var imageSrc = this.canvas.toDataURL();
      const { listItemSvg } = this.state;
      if (listItemSvg.length === 0) {
        return;
      } else {
        const { listItemSvg } = this.state;
        const arr = listItemSvg[0].capturePoint.split(",");
        const convertArr = arr[1].trim().split(" ");
        const markPointCaptureY = Number(convertArr[0]);
        const markPointCaptureX = Number(convertArr[1]);
        this.setState({
          currentX: markPointCaptureX,
          currentY: markPointCaptureY,
        });
      }
      this.urltoFile(imageSrc, fileDrawName, "image/png").then((file) => {
        files.push(file);
        this.openMarkerForm(
          {
            currentShape: "draw",
            currentTime: currentTime,
          },
          () => {
            this.makerForm.onFileChange(null, files);
          }
        );
      });
    };
    img.src = "data:image/svg+xml; charset=utf8, " + encodeURIComponent(svgURL);
  }

  async captureVideoYoutube() {
    const { currentAnimation} = this.props;
    const currentTime = this.state.player
      ? this.state.player.getCurrentTime()
      : 0;
    this.startLoading('Now screenshot... ')
    return this.apiClient.post(`/animations/screen_shot_youtube?id=${currentAnimation.id}&time=${currentTime}`)
      .then((data) => {
        return data.data.image
      })
      .catch(() => {
        Popup.alert('最終稿の設定が失敗しました', '', '', {kind: 'akaire'});
      })
      .finally(() =>{
        this.endLoading()
      });
  }

  urltoFile(url, filename, mimeType) {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  }

  deleteAllDraw() {
    this.setState({
      isDel: false,
      listItemSvg: [],
      shouldShowForm: false,
      zIndexSvg: hideSVGIndex,
      isLargeScreen: true,
    });
  }

  reset() {
    this.setState({
      isDraw: false,
      isDel: false,
      listItemSvg: [],
      shouldShowForm: false,
      zIndexSvg: hideSVGIndex,
      isLargeScreen: true,
    });
    this.ctx = this.canvas.getContext("2d");
    this.ctx.clearRect(0, 0, this.state.canvasWidth, this.state.canvasHeight);
  }

  disableScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    window.onscroll = function() {
      window.scrollTo(scrollLeft, scrollTop);
    };
  }

  enableScroll() {
    window.onscroll = function() {};
  }

  onMouseDown(event, isMobile) {
    if (this.state.isMobileFullScreen) return;
    if (isMobile) {
      document.getElementById("animation-player").style["overflow"] = "hidden";
      document.body.style.overflow = "hidden";
    }
    if (!this.state.isDraw && !this.state.isDel) {
      this.setState({
        isDraw: true,
      });
      var newItem = {
        id: Date.now(),
        points: "",
        color: this.state.settingDraw.color,
        lineWidth: this.state.settingDraw.lineWidth,
        capturePoint: "",
      };
      if (!isMobile) {
        var [x, y] = this.mouseRelativeXYDraw(event);
        newItem.capturePoint = ` , ${y} ${x}`;
      } else {
        var [x, y] = this.touchRelativeXY(event);
        newItem.capturePoint = ` , ${y} ${x}`;
        this.disableScroll();
      }
      this.setState({
        listItemSvg: [...this.state.listItemSvg, newItem],
        currentItemSvg: newItem,
      });
    }
  }

  onMouseMove = (event, isMobile) => {
    if (this.state.isMobileFullScreen) return;
    if (this.state.isDraw) {
      let heightTopToAnimation = fetchHeightHeader();
      var item = document.getElementById(this.state.currentItemSvg.id);
      var points = item.getAttribute("points");
      var capturePoint = item.getAttribute("capturePoint");
      const videoIframe = document.getElementById("id-iframe-video-embed");
      if (isMobile) {
        let xh = event.nativeEvent.layerX;
        let yh = event.nativeEvent.layerY
        xh = (xh * this.state.currentCanvasWidth / videoIframe.offsetWidth).toFixed()
        yh = (yh *  this.state.currentCanvasHeight / videoIframe.offsetHeight).toFixed()
        points += ` ${xh}, ${yh}`;
        var [x, y] = this.mouseRelativeXYDraw(event);
        capturePoint += ` ${x}, ${y}`;
      } else {
        var [x, y] = this.touchRelativeXY(event);
        capturePoint += ` ${x}, ${y}`;
        let xh = event.touches[0].pageX - document.getElementById("animation-player").offsetLeft
        let yh =
          event.touches[0].pageY -
          document.getElementById("animation-player").offsetTop - heightTopToAnimation
        xh = (xh * this.state.currentCanvasWidth / videoIframe.offsetWidth).toFixed()
        yh = (yh *  this.state.currentCanvasHeight / videoIframe.offsetHeight).toFixed()
        points += ` ${xh}, ${yh}`;
      }
      let itemInList = this.state.listItemSvg.find(
        (obj) => obj.id === this.state.currentItemSvg.id
      );
      if (itemInList) {
        itemInList.points = points;
        itemInList.capturePoint = capturePoint;
        itemInList.currentPoints = points;
        itemInList.currentCapturePoint = capturePoint;
      }
      item.setAttribute("points", points);
      item.setAttribute("capturePoint", capturePoint);
    }
  };

  onMouseUp() {
    document.body.style.overflow = "auto";
    const styleOverflow = this.state.shouldShowForm ? 'unset' : 'hidden';
    document.getElementById("animation-player").style["overflow"] = styleOverflow;
    if (this.state.isDraw) {
      this.setState({
        isDraw: false,
      });
      this.enableScroll()
    }
  }

  onItemMouseOver(event) {
    const { mobile } = this.props;
    const polyWidht = event.target.getBBox().width;
    const polyHeight = event.target.getBBox().height;
    if (!this.state.isDraw && this.state.isDel) {
      if (!mobile) {
        event.target.setAttribute("stroke-dasharray", "5 5");
      }
      if (polyWidht <= 35 && polyHeight <= 35) {
        let id = event.target.getAttribute("id");
        let newLists = this.state.listItemSvg.filter((obj) => obj.id != id);
        this.setState({
          listItemSvg: newLists,
        });
      }
    }
  }

  onItemMouseLeave(event) {
    if (!this.state.isDraw && this.state.isDel) {
      event.target.setAttribute("stroke-dasharray", "");
    }
  }

  onChangeFullscreen(isFullscreen) {
    this.setState({ isMobileFullScreen: isFullscreen });
  }

  onDelete(event) {
    if (!this.state.isDraw && this.state.isDel) {
      let id = event.target.getAttribute("id");
      let newLists = this.state.listItemSvg.filter((obj) => obj.id != id);
      this.setState({
        listItemSvg: newLists,
      });
    }
  }

  onReadyVideoEmbed(event) {
    const { mobile } = this.props;
    const player = event.target;
    const iframe = player?.getIframe?.();

    if (iframe) {
      this.configureNativeFullscreenIframe(iframe);
      iframe.style.pointerEvents = 'none';
      iframe.setAttribute('tabindex', '-1');
      if (iframe.parentElement) {
        iframe.parentElement.style.pointerEvents = 'none';
      }
    }

    this.setState({ totalDuration: player.getDuration(), player: player }, () => {
      if (this.timeUpdateInterval) clearInterval(this.timeUpdateInterval);
      this.timeUpdateInterval = setInterval(this.onTimeUpdate, 100);
      if (!mobile) {
        player.playVideo();
      }
    });
  }

  configureNativeFullscreenIframe = (iframe) => {
    if (!iframe) return;

    iframe.setAttribute('allowfullscreen', 'true');
    iframe.setAttribute('webkitallowfullscreen', 'true');
    iframe.setAttribute('mozallowfullscreen', 'true');

    const allow = iframe.getAttribute('allow');
    if (!allow) {
      iframe.setAttribute('allow', 'autoplay; fullscreen');
    } else {
      const nextAllow = allow.includes('fullscreen') ? allow : `${allow}; fullscreen`;
      iframe.setAttribute('allow', nextAllow.includes('autoplay') ? nextAllow : `${nextAllow}; autoplay`);
    }
  }

  // function changed video player state
  changeStateEmbedVideo(event) {
  }

  YouTubeGetID(url) {
    if (url.includes('?v=')) {
      return url.split('?v=')[1].split('&')[0]
    } else if (url.includes('&v=')) {
      return url.split('&v=')[1].split('&')[0]
    } else {
      let regex = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
      return regex.exec(url)[3];
    }
  }

  setOption = () => {
    const { currentAnimationId, animationSelectCurrent } = this.props;
    if (currentAnimationId !== animationSelectCurrent) {
      this.fetchCurrentAnimation()
    }
  }

  handleOutsideClick = (e) => {
    if (!this.nodeModalVersion.contains(e.target)) {
      this.setOption();
    }
  };

  pauseVideo = () => {
    this.state.player.pauseVideo();
  }

  closeAnimationMarkerForm = () => {
    this.setState({ 
      shouldShowForm: false,
      periodRange: null,
      startX: 0,
      startY: 0,
      currentX: 0,
      currentY: 0,
      currentShape: 'point',
      showPeriodRange: []
    })
    if (this.props.isOpenNouislider) {
      this.props.updateIsOpenNouislider()
    }
  }

  fetchCurrentAnimation = () => {
    const { setCurrentAnimation } = this.props;
    this.setState({ isShowModalNotCompareVersion: false }, () => setCurrentAnimation())
  }

  setPeriodRangeWhenClickTimeLine = (periodRange, number_comment) => {
    this.setState({ showPeriodRange: periodRange, commentNumber: number_comment })
  }

  setShowPeriodRangeFromProp = memoize(
    (showPeriodRangeProp) => {
      this.setState({ showPeriodRange: showPeriodRangeProp })
    }
  );

  handlePlaybackRateChange = (rate) => {
    this.state.player.setPlaybackRate(rate);
  }

  render() {
    const { src, downloadUrl, currentUserId, animationMarkerCreationPath, markers, markerCreatable, onClickDownloadButton,
      mobile, onMarkerUpdationCalled, updateMakerShow, role, owner, user, scaleImage, currentAnimation, is_show_draw_component,
      animationSelectCurrent, currentAnimationId, onMarkerDeletionCalled, reloadMarkers, apiClient, deleteReplyMarker, avatarUrl,
      isShowDrawComponent, isOpenNouislider, updateIsOpenNouislider, showPeriodRangeProp,
      is_project_owner_member,
    } = this.props;
    const {
      currentX, currentY, currentWidth, currentHeight, currentShape, shouldShowForm,
      currentTime, markersVisibility, isMarking, isLargeScreen, isShowControlBar, isLoading,
      loadingText, isShowModalNotCompareVersion, showPeriodRange, commentNumber
    } = this.state;
    this.setShowPeriodRangeFromProp(showPeriodRangeProp);

    const src2 = this.YouTubeGetID(src)
    const opts = {
      height: '100%',
      width: '100%',
      playerVars: {
        autoplay: mobile ? 0 : 1,
        mute: mobile ? 0 : 1,
        controls: 0,
        fs: 1,
        playsinline: 1,
      },
    };
    return (
      <div className={mobile ? 'wrap-animation-preview-for-mobile-video' : ''}>
        <div id="wrap-center"
        className={`wrap-animation-preview ${getStyleOfSize(scaleImage,"wrap")}`}
        style={{minHeight:"100%"}}
        >
          <Loadable
            className="loading-overlay"
            active={isLoading}
            text={loadingText || 'Now loading...'}
            zIndex={10000}
          >
          <div

              id="animation-player"
              style={{ width: `${scaleImage}%` }}
              className={classnames("animation-player", { marking: isMarking },{'d-table mt-auto mb-auto':scaleImage && scaleImage <100})}
              ref={this.refCallback}
              onMouseEnter={this.showSeekBar}
              onMouseLeave={this.hintSeekBar}
            >
              <canvas
                id="canvas"
                ref={(ref) => (this.canvas = ref)}
                width={`${this.state.canvasWidth}px`}
                height={`${this.state.canvasHeight}px`}
                style={Object.assign({}, styles.canvas, {
                  zIndex: this.state.zIndexSvg,
                })}
              ></canvas>

              <div
                ref={(ref) => (this.drawSvg = ref)}
                className="draw-svg"
                id="draw-svg"
                style={{
                  zIndex: this.state.zIndexSvg,
                  pointerEvents: this.state.isMobileFullScreen ? 'none' : 'auto'
                }}
                onMouseDown={(event) => this.onMouseDown(event, false)}
                onMouseMove={(event) => this.onMouseMove(event, true)}
                onMouseUp={(event) => this.onMouseUp(event, false)}
                onMouseLeave={() => this.onMouseUp()}
                onTouchStart={(event) => this.onMouseDown(event, true)}
                onTouchEnd={() => this.onMouseUp()}
                onTouchMove={(event) => this.onMouseMove(event, false)}
              >
                <svg
                  viewBox={`0 0 ${this.state.canvasWidth} ${this.state.canvasHeight}`}
                  className={
                    this.state.isDel
                      ? "cursor_eraser"
                      : `cursor_pencil_${this.state.settingDraw.color}`
                  }
                  width={`${this.state.canvasWidth}px`}
                  height={`${this.state.canvasHeight}px`}
                  ref={(ref) => (this.svg = ref)}
                  style={Object.assign({}, styles.canvas, {
                    zIndex: this.state.zIndexSvg,
                  })}
                >
                  {this.state.listItemSvg.map((item, i) => (
                    <PolyLineSvg
                      id={item.id}
                      points={item.points}
                      color={item.color}
                      lineWidth={item.lineWidth}
                      onItemMouseOver={(event) => this.onItemMouseOver(event)}
                      onItemMouseLeave={(event) => this.onItemMouseLeave(event)}
                      onDelete={(event) => this.onDelete(event)}
                    />
                  ))}
                </svg>
              </div>
              {src2 ? (
              <div style={{paddingTop: isLargeScreen ? 9/16 * 100 + '%' : "auto"}}
                  className='video-embed custom-youtube-player'
                  id="iframe-show-video"
                  ref={(ref) => (this.playerContainerRef = ref)}>
                {<YouTube
                  ref={(ref) => (this.player = ref)}
                  videoId={src2} opts={opts} onReady={(event) => this.onReadyVideoEmbed(event)}
                  className="iframe-video-embed" id="id-iframe-video-embed"
                  onStateChange={(event) => this.changeStateEmbedVideo(event)}
                  crossOrigin="anonymous"
                />}
                {/* Custom YouTube Controls */}
                {this.state.player && (
                  <YouTubeControls 
                    key={`youtube-controls-${src2}-${currentAnimationId || ''}`}
                    player={this.state.player}
                    containerRef={this.playerContainerRef}
                    opts={opts}
                    onChangeFullscreen={this.onChangeFullscreen.bind(this)}
                    handlePlaybackRateChange={this.handlePlaybackRateChange.bind(this)}
                    mobile={mobile}
                  />
                )}
                {
                  markerCreatable && this.renderOverlay()
                }
                {
                  isMarking && <MarkShape x={currentX} y={currentY} width={currentWidth} height={currentHeight} shape={currentShape} isCommentPeriod={isOpenNouislider} />
                }
                {
                  !this.state.isMobileFullScreen && (
                    <AnimationMarkersInPlayer
                      markers={this.activeMarkers()}
                      visibility={markersVisibility}
                      order={11}
                      onMarkerUpdationCalled={onMarkerUpdationCalled}
                      image={this.player}
                      updateMakerShow={updateMakerShow}
                    />
                  )
                }
                {
                  shouldShowForm && (
                    <AnimationMarkerForm
                      ref={(ref) => (this.makerForm = ref)}
                      x={currentX} y={currentY} width={currentWidth} height={currentHeight} shape={currentShape}
                      time={currentTime} onSubmit={this.onSubmitMarkerForm}
                      onClickClose={this.closeAnimationMarkerForm} order={12}
                      mobile={mobile} shouldShowForm={shouldShowForm} currentUserId={currentUserId}
                      role={role} owner={owner} user={user}
                      scaleImage={scaleImage}
                      captureVideoYoutube={this.captureVideoYoutube.bind(this)}
                      is_embed_video={true}
                      canvas={this.canvas}
                      is_show_draw_component={is_show_draw_component}
                      onlyBUAForCommentPeriod={isOpenNouislider}
                    />
                  )
                }
                
                <Shortcut ref="shortcut" />
              </div>
              ) : (
                <div style={{paddingTop: isLargeScreen ? 9/16 * 100 + '%' : "auto"}}
                  className='video-embed'
                  id="iframe-show-video">
                  {currentAnimation.title}バージョンのURLは削除されました。
                </div>
              ) }
          </div>
          </Loadable>
          <CommentDetail
            selectedMarker={this.props.selectedMarker}
            updateSelectedMarker={this.props.updateSelectedMarker}
            onMarkerUpdationCalled={onMarkerUpdationCalled}
            currentUserId={currentUserId}
            owner={owner}
            role={role}
            animationSelectCurrent={animationSelectCurrent}
            currentAnimationId={currentAnimationId}
            onMarkerDeletionCalled={onMarkerDeletionCalled}
            reloadMarkers={reloadMarkers}
            apiClient={apiClient}
            markers={markers}
            deleteReplyMarker={deleteReplyMarker}
            avatarUrl={avatarUrl}
            shouldShowForm={shouldShowForm}
            is_project_owner_member={is_project_owner_member}
          />
          <div ref={nodeModalVersion => { this.nodeModalVersion = nodeModalVersion }}>
            <Modal isOpen={isShowModalNotCompareVersion}
                className="animation-uploader-modal modal-dialog-centered modal-not-compare-version"
                size="md" >
              <ModalBody>
                <div className='text-center text-black'>
                  <div className='font-size-17px font-weight-bold text-black text-center'>
                    <span>メディア画面とコメントツールの </span>
                    <span>バージョンが異なる為、赤入れできません。</span>
                  </div>
                  <Button className="btn btn-danger my-2 button-set-current-animation" onClick={this.fetchCurrentAnimation}>
                    表示中のメディア画面を赤入れする
                  </Button>
                  <span>
                    ※クリックするとコメントツールのバージョンが{currentAnimation.final ? '最終稿' : currentAnimation.title}に変わります。
                  </span>
                </div>
              </ModalBody>
            </Modal>
          </div>
        </div>
        <div className="comment-timeline-container"
        style={{paddingTop:"10px"}}>
          <AnimationMarkerLine markers={markers}
            duration={this.state.totalDuration}
            player={this.state.player}
            isEmbedVideo={true}
            order={10}
            isShowDrawComponent={isShowDrawComponent}
            setPeriodRangeWhenClickTimeLine={this.setPeriodRangeWhenClickTimeLine}
            onMarkerLineClicked={this.props.onMarkerLineClicked}
          />
          <AnimationMarkerPeriod
            duration={this.state.totalDuration}
            player={this.state.player}
            isEmbedVideo={true}
            openPeriodCommentBox={this.openPeriod}
            isOpenNouislider={isOpenNouislider}
            updateIsOpenNouislider={updateIsOpenNouislider}
            showPeriodRange={showPeriodRange}
            commentNumber={commentNumber}
            onMarkerPeriodChanged={this.props.onMarkerPeriodChanged}
            commentPeriodContainer={this.props.commentPeriodContainer}
          ></AnimationMarkerPeriod>
        </div>
      </div>
    )
  }
}
